/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import Video from "../creator/video";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddVideoModal from "../Modals/AddVideo";
import DeleteModal from "../Modals/DeleteModal";
import Loader from "react-js-loader";
import style from "./styles.module.css";
const useStyles = makeStyles({
  main: {
    display: "flex",
    justifyContent: "space-between",
    padding: "2% 0%",
    alignItems: "center",
    margin: "1%",
  },
  head: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&>*": {
      marginLeft: "20px",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    width: "300px",
    border: "none",
    padding: "10px",
    fontSize: "16px",
    outline: "none",
    color: "#818588",
    background: "#f3f5f6",
    fontWeight: 500,
  },
  button: {
    padding: "11px ",
    border: "3px solid",
    borderImage: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    borderImageSlice: 20,
    cursor: "pointer",
  },
  delete: {
    padding: "1% 3%",
    border: "none",
    color: "white",
    background: "red",
    cursor: "pointer",
  },
  text1: {
    fontFamily: "Epilogue",
    fontSize: "30px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "31px",
    letterSpacing: "0em",
    textAlign: "left",
    margin: "5% 3%",
    paddingTop: "10px",
  },
});

function VideoList({ setList, list }) {
  // const {videos,setVideo} = useContext(PlayListContext);
  console.log("list", list);
  const styles = useStyles();
  const [detail, setDetail] = useState([]);
  const [status, setStatus] = useState(null);
  const [addVideo, setAddVideo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteP, setDelete] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  // const setUrl = (videos) => {
  //   let YT_url =
  //     "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
  //   const key = "&key=AIzaSyDIcBfTRXG5W4G4QzzlkBDSN6W9Y3RXjQM";

  //   for (let i = 0; i < videos.length; i++) {
  //     if (i === 0) {
  //       YT_url += videos[i].slice(17);
  //     } else {
  //       YT_url += "%2C" + videos[i].slice(17);
  //     }
  //   }
  //   YT_url += key;
  //   console.log("YT_url", YT_url);
  //   return YT_url;
  // };

  // useEffect(async () => {
  //   setLoading(true);
  //   const config = {
  //     method: "get",
  //     url: setUrl(videos),
  //   };

  //   const result = await axios(config);
  //   console.log("result", result);
  //   setDetail(result.data.items);
  //   setLoading(false);
  // }, [videos]);

  return (
    <>
      <div className={styles.main}>
        <div className={styles.head}>
          <button
            className={styles.button}
            onClick={() => setAddVideo((val) => !val)}
          >
            Add Video
          </button>
        </div>
        <button
          className={styles.delete}
          onClick={() => setDelete((val) => !val)}
        >
          Delete Playlist
        </button>
      </div>

      <div>
        <span className={styles.text1}>{list.name}</span>
      </div>
      {loading && (
        <Loader
          type="bubble-top"
          bgColor={"#000000"}
          color={"#000000"}
          title="Loading Videos"
        />
      )}
      <div className={styles.videos}>
        <div className={style.thumnails}>
          {list &&
            list?.videos?.map((v) => (
              <Video
                del={true}
                video={v}
                setStatus={setStatus}
                list={list}
                toast={toast}
              />
            ))}
        </div>
        {status === true && <ToastContainer />}
        {status === false && <ToastContainer />}
        {deleteError && <ToastContainer />}
        {deleteError === false && <ToastContainer />}
        {addVideo && (
          <AddVideoModal open={addVideo} setOpen={setAddVideo} list={list} />
        )}
        {deleteP && (
          <DeleteModal
            open={deleteP}
            setOpen={setDelete}
            list={list}
            setDelete={setDeleteError}
            toast={toast}
          />
        )}
      </div>
    </>
  );
}

export default VideoList;
